import { required } from "@vuelidate/validators"

const ASSET_PROVISION_FORM_DATA = {
  name: "",
  id: "",
  description: "",
  contentType: "",
  version: "",
  keywords: "",
  language: "English"
}

const ASSET_PROVISION_FORM_RULES = {
  name: { required },
  id: { required }
}

export { ASSET_PROVISION_FORM_DATA, ASSET_PROVISION_FORM_RULES }
